import React, { useState, useEffect } from 'react';
import { Row, Col, Typography, Card, Table, Tag, Form, Button, Space, Input } from 'antd';
import MainLayout from '../../layouts/MainLayout';
import { financialApi } from '../../utils/financialApi';
import dayjs from 'dayjs';
import jalaliday from 'jalali-dayjs';

dayjs.extend(jalaliday);
const { Title, Text } = Typography;

const AuditLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form] = Form.useForm();

  const fetchLogs = async (params = {}) => {
    try {
      setLoading(true);
      const res = await financialApi.getAuditLogs(params);
      const data = res?.data || res;
      const lg = Array.isArray(data) ? data : data?.logs; setLogs(Array.isArray(lg) ? lg : []);
    } catch (error) {
      console.error('Failed to fetch audit logs:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  const handleFilter = (values) => {
    const params = {};
    if (values.auditable_type) params.auditable_type = values.auditable_type;
    if (values.auditable_id) params.auditable_id = Number(values.auditable_id);
    fetchLogs(params);
  };

  const resetFilter = () => {
    form.resetFields();
    fetchLogs();
  };

  const columns = [
    {
      title: 'ردیف',
      dataIndex: 'id',
      key: 'id',
      render: (id) => <Text className="font-semibold text-gray-500">#{id}</Text>,
    },
    {
      title: 'مدل',
      dataIndex: 'auditable_type',
      key: 'auditable_type',
    },
    {
      title: 'شناسه مرجع',
      dataIndex: 'auditable_id',
      key: 'auditable_id',
    },
    {
      title: 'عملیات',
      dataIndex: 'event',
      key: 'event',
      render: (event) => (
        <Tag color={event === 'created' ? 'success' : event === 'updated' ? 'processing' : 'error'}>
          {event}
        </Tag>
      ),
    },
    {
      title: 'کاربر',
      dataIndex: ['user', 'name'],
      key: 'user',
      render: (name, record) => name || `کاربر ${record.user_id || '-'}`,
    },
    {
      title: 'تاریخ ثبت',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (date) => (
        <span dir="ltr">
          {date ? dayjs(date).calendar('jalali').format('YYYY/MM/DD HH:mm:ss') : '-'}
        </span>
      ),
    },
  ];

  return (
    <MainLayout>
      <div className="p-4 md:p-6 pb-24 max-w-[1600px] mx-auto animate-fade-in">
        <div className="mb-6">
          <Title level={3} className="m-0 text-gray-800 dark:text-gray-100 font-bold">
            لاگ‌های ممیزی مالی
          </Title>
          <Text className="text-gray-500 dark:text-gray-400">
            تاریخچه تغییرناپذیر عملیات حساس در ماژول مالی
          </Text>
        </div>

        <Card bordered={false} className="shadow-sm dark:bg-gray-800 rounded-2xl mb-6">
          <Form form={form} layout="inline" onFinish={handleFilter}>
            <Form.Item name="auditable_type" label="نوع موجودیت (مانند: Payment)">
              <Input placeholder="مثال: Payment" />
            </Form.Item>
            <Form.Item name="auditable_id" label="شناسه موجودیت">
              <Input type="number" />
            </Form.Item>
            <Form.Item>
              <Space>
                <Button type="primary" htmlType="submit">جستجو</Button>
                <Button onClick={resetFilter}>پاک کردن</Button>
              </Space>
            </Form.Item>
          </Form>
        </Card>

        <Card 
          loading={loading}
          bordered={false} 
          className="shadow-sm dark:bg-gray-800 rounded-2xl h-full"
        >
          <Table 
            dataSource={logs} 
            columns={columns}
            rowKey="id"
            pagination={true}
            size="middle"
            className="custom-table"
            locale={{ emptyText: 'لاگی یافت نشد' }}
          />
        </Card>
      </div>
    </MainLayout>
  );
};

export default AuditLogs;
